import { Tooltip, Whisper } from 'rsuite';
import noImage from '../../../../../../assets/icons/no-image.svg';
import { useElasticidadeCruzadaStore } from '../../ElasticidadeCruzada.store';
import styles from './styles.module.scss';

export const ProductReferenceCard = () => {
  const { produtoReferenciaInfo } = useElasticidadeCruzadaStore();

  if (!produtoReferenciaInfo) return null;

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <img
            src={produtoReferenciaInfo.imagemUrl || noImage}
            alt={produtoReferenciaInfo.nome}
            className={styles.productImage}
            onError={e => {
              (e.target as HTMLImageElement).src = noImage;
            }}
          />
        </div>
        <div className={styles.info}>
          <Whisper delayShow={200} trigger="hover" placement="top" speaker={<Tooltip>{produtoReferenciaInfo.nome}</Tooltip>}>
            <h3 className={styles.productName}>{produtoReferenciaInfo.nome}</h3>
          </Whisper>
          <p className={styles.productEan}>{produtoReferenciaInfo.gtin}</p>
        </div>
        <div className={styles.badge}>REFERÊNCIA</div>
      </div>
    </div>
  );
};
